import Nullstack from 'nullstack';
export default function IconConfetti({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-confetti",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 5h2"
  }), "   ", Nullstack.element("path", {
    d: "M5 4v2"
  }), "   ", Nullstack.element("path", {
    d: "M11.5 4l-.5 2"
  }), "   ", Nullstack.element("path", {
    d: "M18 5h2"
  }), "   ", Nullstack.element("path", {
    d: "M19 4v2"
  }), "   ", Nullstack.element("path", {
    d: "M15 9l-1 1"
  }), "   ", Nullstack.element("path", {
    d: "M18 13l2 -.5"
  }), "   ", Nullstack.element("path", {
    d: "M18 19h2"
  }), "   ", Nullstack.element("path", {
    d: "M19 18v2"
  }), "   ", Nullstack.element("path", {
    d: "M14 16.518l-6.518 -6.518l-4.39 9.58a1.003 1.003 0 0 0 1.329 1.329l9.579 -4.39z"
  }), " ");
}